/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';

function CollaboratorsEditViewController(this: JS5Object, _: JS5Object, $location: JS5Object, $route: JS5Object, $routeParams: JS5Object,
                                         uiGridConstants: JS5Object, NetworkViewService: JS5Object, $timeout: JS5Function,
                                         BreadcrumbService: JS5Object, CollaboratorsService: JS5Object, PermissionsService: JS5Object,
                                         UtilsService: JS5Object, SidebarService: JS5Object) {

    let initializeBreadcrumbs = () => {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            name: 'Collaborators',
            location: $route.current.rootRoute
        });
    };

    let columnDefinitions = [
        {
            field: 'type',
            displayName: 'Role',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'contentName',
            displayName: 'Content Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object): void => {
            this.CollaboratorsGridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };

    this.paginationDefs = {
        paginationPrevPageHandler: this.paginationPrevPageHandler,
        paginationNextPageHandler: this.paginationNextPageHandler,
        paginationPageSizeChanged: this.paginationPageSizeChanged,
    };

    this.getData = () => {
        this.loadingIndicator.show = true;

        const collaboratorId = $routeParams.id;

        let criteria = {
            id: collaboratorId
        };
        CollaboratorsService.getCollaboratorById(criteria).then((collaborator: JS5Object): void => {
            this.editData = collaborator;
            this.loadingIndicator.show = false;
            CollaboratorsService.originalEditData = _.cloneDeep(collaborator);
            CollaboratorsService.getCollaboratorRoles(criteria).then((roles: JS5Object): void => {
                roles.forEach((role: JS5Object) => {
                    if (role.type === 'Crew') {
                        role.contentName = role.role;
                    }
                });
                this.editData['roles'] = roles;
                this.gridOptions.data = this.editData.roles;
            });
        });

    };

    this.saveEditData = () => {
        this.loadingIndicator.show = true;
        let collaboratorWithoutRoles = angular.copy(this.editData);
        delete collaboratorWithoutRoles.roles;
        CollaboratorsService.updateCollaborator(collaboratorWithoutRoles).then((savedCollaborator: JS5Object) => {
            CollaboratorsService.originalEditData = _.cloneDeep(savedCollaborator);
            this.editorForm.$pristine = true;
            this.editorForm.$setPristine();
            this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => {
                return this.editorForm && !this.editorForm.$pristine && _.get(this, 'permissions.write');
            },
            onClick: () => {
                if (_.get(this, 'permissions.write')) {
                    this.saveEditData()
                }
            }
        },
        {
            label: 'Revert',
            enabled: () => {
                return this.editorForm && !this.editorForm.$pristine && _.get(this, 'permissions.write');
            },
            onClick: () => {
                this.editData = _.cloneDeep(CollaboratorsService.originalEditData);
                this.editorForm.$pristine = true;
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => {
                return this.editorForm && !this.editorForm.$dirty;
            },
            onClick: () => {
                $location.url($route.current.rootRoute)
            }
        }
    ];

    this.$onInit = () => {
        initializeBreadcrumbs();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        SidebarService.editService = CollaboratorsService;
        PermissionsService.getReadWritePermissions(CollaboratorsService.permissionViewState).then((permissions: JS5Object) => {
            this.permissions = permissions;
            this.getData();
        });
    };

    this.$postLink = () => {
        $timeout(() => {
            CollaboratorsService.editorForm = this.editorForm;
            BreadcrumbService.editService = CollaboratorsService;
        });
    };

    this.$onDestroy = () => {
        BreadcrumbService.clearBreadcrumbs();
        this.editData = null;
    };
    this.handleDisplayNameChange = () => {
        _.set(this.editData, 'sortName', _.cloneDeep(UtilsService.transformDisplayNameToSortName(_.get(this.editData, 'displayName'))));
    }
}

angular.module('prism-ui.collaborators').component('collaboratorsEditView', {
    templateUrl: 'meta/collaborator/editView/collaborators-edit-view-template.html',
    controller: CollaboratorsEditViewController
});
